import { render, staticRenderFns } from "./ReferringPhysician.vue?vue&type=template&id=33e7cd7a&scoped=true"
import script from "./ReferringPhysician.vue?vue&type=script&lang=js"
export * from "./ReferringPhysician.vue?vue&type=script&lang=js"
import style0 from "./ReferringPhysician.vue?vue&type=style&index=0&id=33e7cd7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e7cd7a",
  null
  
)

export default component.exports